import adminApi from './admin.js'
import authApi from './auth.js'
import calculcationApi from './calculcation.js'
import cloneApi from './clone.js'
import copyrightApi from './copyright.js'
import dataApi from './data.js'
import dataGraphApi from './dataGraph.js'
import dayanTaskApi from './dayanTask.js'
import deployApi from './deploy.js'
import deployRefreshApi from './deploy-refresh.js'
import desktopApi from './desktop.js'
import dongleApi from './dongle.js'
import exportApi from './export.js'
import feedbackApi from './feedback.js'
import financeApi from './finance.js'
import homeApi from './home.js'
import materialApi from './material.js'
import monitorApi from './monitor.js'
import nodeApi from './node.js'
import outsourcingApi from './outsourcing.js'
import packApi from './pack.js'
import statisticsApi from './statistics.js'
import storageApi from './storage.js'
import submitAnalysisApi from './submitAnalysis.js'
import taskApi from './task.js'
import ticketApi from './ticket.js'
import transmissionApi from './transmission.js'
import userApi from './user.js'

// axios的导入采用动态导入，命名空间以文件名+Api组成，例如auth.js模块为 authApi

import './config/config.js'

const apis = {
  adminApi,
  authApi,
  calculcationApi,
  cloneApi,
  copyrightApi,
  dataApi,
  dataGraphApi,
  dayanTaskApi,
  deployApi,
  deployRefreshApi,
  desktopApi,
  dongleApi,
  exportApi,
  feedbackApi,
  financeApi,
  homeApi,
  materialApi,
  monitorApi,
  nodeApi,
  outsourcingApi,
  packApi,
  statisticsApi,
  storageApi,
  submitAnalysisApi,
  taskApi,
  ticketApi,
  transmissionApi,
  userApi,
}

// // 使用 webpack 的 require.context 动态导入所有 API 模块
// // 参数说明：
// // 1. '.' - 当前目录
// // 2. false - 不遍历子目录
// // 3. /\.js$/ - 匹配所有 .js 文件
// const requireModule = require.context('.', false, /\.js$/)

// requireModule.keys().forEach(fileName => {
//   // 排除不需要导入的文件
//   if (['./index.js', './config.js', './default.js'].includes(fileName)) {
//     return
//   }

//   // 获取模块
//   const moduleConfig = requireModule(fileName)

//   // 提取文件名（去掉 ./ 和 .js）
//   const moduleName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')

//   // 组装成 XXXApi 的形式
//   apis[`${moduleName}Api`] = moduleConfig.default || moduleConfig
// })

export default apis
